import reducer from './reducers';
import * as fileTypes from './types';

export { fileTypes };

export default reducer;
